import _ from 'lodash';

import protos from 'utils/protos';

const { Service } = protos;

export const ServiceOptions = _.map(Service.Type, (enumVal: number, enumString: string) => {
  return {
    key: enumString,
    label: _.capitalize(enumString),
    value: enumVal,
  };
}) as SelectOption[];
